import { useMediaQuery, useTheme } from "@mui/material";

export const useQueryMedia = () => {
  const theme = useTheme();
  const isXLarge = useMediaQuery(theme.breakpoints.only("xl"));
  const isLarge = useMediaQuery(theme.breakpoints.only("lg"));
  const isMedium = useMediaQuery(theme.breakpoints.only("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmall = useMediaQuery(theme.breakpoints.only("sm"));
  const isExtraSmall = useMediaQuery(theme.breakpoints.only("xs"));

  return { isMobile, isSmall, isExtraSmall, isMedium, isLarge, isXLarge };
};
